import { sb } from '../supabase.ts';
import { escapeHtml } from '../main.ts';
import { IMGBB_API_KEY } from '../config.ts';

export async function renderDataEditPage(app: HTMLElement) {
  const tableName = 'student_database';
  
  const allCols = [
    { id: 'session', label: 'session' },
    { id: 'student_name_en', label: 'student_name_en' },
    { id: 'student_name_bn', label: 'student_name_bn' },
    { id: 'birth_registration', label: 'birth_registration' },
    { id: 'student_dateofbirth', label: 'student_dateofbirth' },
    { id: 'student_gender', label: 'student_gender' },
    { id: 'religion', label: 'religion' },
    { id: 'student_blood_group', label: 'student_blood_group' },
    { id: 'active_class', label: 'active_class' },
    { id: 'active_section', label: 'active_section' },
    { id: 'active_roll', label: 'active_roll' },
    { id: 'class_2026', label: 'class_2026' },
    { id: 'section_2026', label: 'section_2026' },
    { id: 'roll_2026', label: 'roll_2026' },
    { id: 'class_2025', label: 'class_2025' },
    { id: 'section_2025', label: 'section_2025' },
    { id: 'roll_2025', label: 'roll_2025' },
    { id: 'class_2024', label: 'class_2024' },
    { id: 'section_2024', label: 'section_2024' },
    { id: 'roll_2024', label: 'roll_2024' },
    { id: 'father_name_en', label: 'father_name_en' },
    { id: 'father_name_bn', label: 'father_name_bn' },
    { id: 'father_nid', label: 'father_nid' },
    { id: 'father_mobile', label: 'father_mobile' },
    { id: 'father_occupation', label: 'father_occupation' },
    { id: 'father_dob', label: 'father_dob' },
    { id: 'father_blood_group', label: 'father_blood_group' },
    { id: 'mother_name_en', label: 'mother_name_en' },
    { id: 'mother_name_bn', label: 'mother_name_bn' },
    { id: 'mother_nid', label: 'mother_nid' },
    { id: 'mother_mobile', label: 'mother_mobile' },
    { id: 'mother_occupation', label: 'mother_occupation' },
    { id: 'mother_dob', label: 'mother_dob' },
    { id: 'mother_blood_group', label: 'mother_blood_group' },
    { id: 'guardian_name_en', label: 'guardian_name_en' },
    { id: 'guardian_name_bn', label: 'guardian_name_bn' },
    { id: 'guardian_nid', label: 'guardian_nid' },
    { id: 'guardian_mobile', label: 'guardian_mobile' },
    { id: 'guardian_occupation', label: 'guardian_occupation' },
    { id: 'board_name', label: 'board_name' },
    { id: 'board_roll', label: 'board_roll' },
    { id: 'board_registration', label: 'board_registration' },
    { id: 'group', label: 'group' },
    { id: 'optional_subject', label: 'optional_subject' },
    { id: 'village_en', label: 'village_en' },
    { id: 'village_bn', label: 'village_bn' },
    { id: 'postoffice_en', label: 'postoffice_en' },
    { id: 'postoffice_bn', label: 'postoffice_bn' },
    { id: 'union_en', label: 'union_en' },
    { id: 'union_bn', label: 'union_bn' },
    { id: 'upazilla_en', label: 'upazilla_en' },
    { id: 'upazilla_bn', label: 'upazilla_bn' },
    { id: 'district_en', label: 'district_en' },
    { id: 'district_bn', label: 'district_bn' },
    { id: 'previous_school', label: 'previous_school' },
    { id: 'comment_school', label: 'comment_school' },
    { id: 'admission_date', label: 'admission_date' },
    { id: 'previous_class_roll', label: 'previous_class_roll' },
    { id: 'school_reg_sl', label: 'school_reg_sl' },
    { id: 'quote_freedomfighter', label: 'quote_freedomfighter' },
    { id: 'status', label: 'status' },
    { id: 'tc_date', label: 'tc_date' },
    { id: 'tc_no', label: 'tc_no' },
    { id: 'rfid_card_no', label: 'rfid_card_no' },
    { id: 'fulldata_ok', label: 'fulldata_ok' },
    { id: 'student_key', label: 'student_key' },
    { id: 'student_photo_url', label: 'student_photo_url' },
    { id: 'birth_certificate_url', label: 'birth_certificate_url' },
    { id: 'registration_card_url', label: 'registration_card_url' }
  ];

  const styles = `
    <style>
      .edit-container { font-family: sans-serif; padding: 20px; background: #f4f6f8; min-height: 100vh; }
      .control-panel { background: #fff; padding: 15px; border-radius: 8px; border: 1px solid #ddd; margin-bottom: 20px; }
      .btn-row { display: flex; gap: 10px; margin-bottom: 15px; }
      .btn-small { padding: 4px 12px; font-size: 13px; border: 1px solid #ccc; background: #fff; cursor: pointer; border-radius: 4px; }
      .col-grid { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; padding: 10px 0; }
      .col-item { display: flex; align-items: center; gap: 6px; font-size: 11px; padding: 3px 6px; border: 1px solid #eee; border-radius: 4px; background: #fff; }

      .filter-row { display: flex; gap: 20px; align-items: center; margin-bottom: 20px; padding: 15px; background: #fff; border-radius: 8px; border: 1px solid #ddd; box-shadow: 0 1px 3px rgba(0,0,0,0.1); }
      .filter-row select { padding: 6px; border: 1px solid #ccc; border-radius: 4px; }
      
      .table-wrapper { background: #fff; border: 1px solid #ddd; border-radius: 4px; overflow: auto; }
      table { width: 100%; border-collapse: collapse; font-size: 13px; }
      th, td { border: 1px solid #eee; padding: 10px; text-align: left; vertical-align: middle; }
      th { background: #f8f9fa; font-weight: 600; color: #555; position: sticky; top: 0; z-index: 10; }
      .val-input { width: 100%; padding: 6px; border: 1px solid #ddd; border-radius: 4px; font-size: 13px; }
      .update-btn { background: #0061f2; color: #fff; border: none; padding: 6px 12px; border-radius: 4px; cursor: pointer; font-size: 12px; font-weight: 600; transition: background 0.2s; }
      .update-btn:hover { background: #004dc2; }
      .update-btn.dirty { background: #f59e0b; }
      .update-btn.dirty:hover { background: #d97706; }
      .muted-label { color: #6366f1; font-size: 11px; margin-top: 8px; display: block; font-weight: 600; }

      .edit-config-row { display: flex; gap: 15px; align-items: center; padding: 12px 15px; background: #f8fafc; border-radius: 8px; border: 1px solid #e2e8f0; margin-bottom: 15px; }
      .edit-config-row label { font-size: 13px; font-weight: 600; color: #475569; }
      .edit-config-row select { padding: 6px 10px; border: 1px solid #cbd5e1; border-radius: 6px; font-size: 13px; background: white; }

      .row-thumb { width: 30px; height: 38px; object-fit: cover; border-radius: 4px; border: 1px solid #ddd; cursor: pointer; }
      #photo-preview { position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); background: #fff; border: 2px solid #ddd; border-radius: 8px; padding: 12px; box-shadow: 0 10px 40px rgba(0,0,0,0.35); z-index: 10001; display: none; pointer-events: none; }
      #photo-preview img { max-width: 500px; max-height: 600px; object-fit: contain; }
    </style>
  `;

  app.innerHTML = styles + `
    <div class="edit-container">
      <h1 class="school-title">FENI MODEL HIGH SCHOOL</h1>
      
      <div class="filter-row">
        <label>Session</label><select id="sessionSelect"></select>
        <label>Class</label><select id="classSelect"></select>
        <label>Section</label><select id="sectionSelect"></select>
        <span id="status" style="margin-left:auto; font-size:12px; color:#666;"></span>
      </div>

      <div class="edit-config-row">
        <label>Edit Mode:</label>
        <select id="editCount">
          <option value="1">1 Column (Last selected)</option>
          <option value="2">2 Columns (Last two selected)</option>
        </select>
      </div>

      <div class="control-panel">
        <div class="btn-row">
          <button id="selectAll" class="btn-small">Select all</button>
          <button id="clearAll" class="btn-small">Clear</button>
        </div>
        <div class="col-grid" id="colGrid"></div>
        <span class="muted-label">Selected columns above will be shown in the table. The columns picked for editing will be input fields.</span>
      </div>

      <div class="table-wrapper">
        <table id="editTable">
          <thead><tr id="theadRow"></tr></thead>
          <tbody id="tbody"></tbody>
        </table>
      </div>
    </div>
    <div id="photo-preview"><img src="" alt="preview"/></div>
  `;

  const colGrid = document.getElementById('colGrid')!;
  const sessionSelect = document.getElementById('sessionSelect') as HTMLSelectElement;
  const classSelect = document.getElementById('classSelect') as HTMLSelectElement;
  const sectionSelect = document.getElementById('sectionSelect') as HTMLSelectElement;
  const theadRow = document.getElementById('theadRow')!;
  const tbody = document.getElementById('tbody')!;
  const status = document.getElementById('status')!;
  const editCount = document.getElementById('editCount') as HTMLSelectElement;

  const savedSes = localStorage.getItem('edit_ses') || '2026';
  const savedCls = localStorage.getItem('edit_cls') || '';
  const savedSec = localStorage.getItem('edit_sec') || '';
  const savedCols = localStorage.getItem('edit_cols');
  const savedEditCount = localStorage.getItem('edit_mode_count') || '1';

  let selectedCols: string[] = savedCols ? JSON.parse(savedCols) : ['session', 'student_name_bn', 'birth_registration', 'student_dateofbirth'];
  let currentRows: any[] = [];
  let editableCols: string[] = [];

  function saveSettings() {
    localStorage.setItem('edit_ses', sessionSelect.value);
    localStorage.setItem('edit_cls', classSelect.value);
    localStorage.setItem('edit_sec', sectionSelect.value);
    localStorage.setItem('edit_cols', JSON.stringify(selectedCols));
    localStorage.setItem('edit_mode_count', editCount.value);
  }


  function renderCheckboxes() {
    updateEditableCols();
    colGrid.innerHTML = allCols.map(c => `
      <div class="col-item">
        <input type="checkbox" id="c-${c.id}" data-id="${c.id}" ${selectedCols.includes(c.id) ? 'checked' : ''}>
        <label for="c-${c.id}">${c.label}${editableCols.includes(c.id) ? ' <span style="color:#6366f1">(Edit)</span>' : ''}</label>
      </div>
    `).join('');

    colGrid.querySelectorAll('input').forEach(chk => {
      chk.onchange = (e: any) => {
        const id = e.target.dataset.id;
        if (e.target.checked) {
          if (!selectedCols.includes(id)) selectedCols.push(id);
        } else {
          selectedCols = selectedCols.filter(x => x !== id);
        }
        renderCheckboxes();
        fetchData();
        saveSettings();
      };
    });
  }

  // Init Filters
  sessionSelect.innerHTML = ['2022','2023','2024','2025','2026','2027','2028'].map(s => `<option value="${s}" ${s===savedSes?'selected':''}>${s}</option>`).join('');

  async function loadClasses(targetCls?: string) {
    const ses = sessionSelect.value;
    const { data } = await sb.from(tableName).select(`class_${ses}`).not(`class_${ses}`, 'is', null);
    const set = new Set<string>();
    (data||[]).forEach((r: any) => set.add(String(r[`class_${ses}`])));
    classSelect.innerHTML = '<option value="">Select Class</option>' + Array.from(set).sort().map(c => `<option value="${c}" ${c===targetCls?'selected':''}>${c}</option>`).join('');
  }

  async function loadSections(targetSec?: string) {
    const ses = sessionSelect.value;
    const cls = classSelect.value;
    const { data } = await sb.from(tableName).select(`section_${ses}`).eq(`class_${ses}`, cls).not(`section_${ses}`, 'is', null);
    const set = new Set<string>();
    (data||[]).forEach((r: any) => set.add(String(r[`section_${ses}`])));
    sectionSelect.innerHTML = '<option value="">All Sections</option>' + Array.from(set).sort().map(s => `<option value="${s}" ${s===targetSec?'selected':''}>${s}</option>`).join('');
  }

  async function fetchData() {
    const ses = sessionSelect.value;
    const cls = classSelect.value;
    const sec = sectionSelect.value;
    if (!ses || !cls) { tbody.innerHTML = ''; return; }

    status.textContent = 'Loading...';
    // Always fetch fixed cols + all selected cols + editable cols
    const fetchList = Array.from(new Set(['iid', 'student_name_en', ...selectedCols, ...editableCols]));
    let query = sb.from(tableName).select(fetchList.join(',')).eq(`class_${ses}`, cls);
    if (sec) query = query.eq(`section_${ses}`, sec);
    
    const { data, error } = await query.order(`roll_${ses}`, { ascending: true }).limit(2000);
    if (error) { status.textContent = 'Error'; return; }
    
    currentRows = data || [];
    status.textContent = `Total: ${currentRows.length}`;
    refreshTable();
  }

  const dropdownOptions: Record<string, string[]> = {
    religion: ['Islam', 'Hinduism', 'Christianity', 'Buddhism', 'Others'],
    student_gender: ['Male', 'Female'],
    student_blood_group: ['A+', 'A-', 'B+', 'B-', 'O+', 'O-', 'AB+', 'AB-'],
    status: ['Active', 'TC', 'Dropout', 'Passed'],
    fulldata_ok: ['OK', 'Pending', 'Incomplete'],
    quote_freedomfighter: ['Yes', 'No'],
    group: ['General', 'Science', 'Humanities', 'Business Studies'],
    active_class: ['6', '7', '8', '9', '10'],
    class_2024: ['6', '7', '8', '9', '10'],
    class_2025: ['6', '7', '8', '9', '10'],
    class_2026: ['6', '7', '8', '9', '10'],
    active_section: [],
    section_2024: [],
    section_2025: [],
    section_2026: [],
  };

  let addressData: any[] = [];
  async function loadAddressData() {
    try {
      const res = await fetch('/src/address_info.csv');
      const text = await res.text();
      const rows = text.split('\n').filter(r => r.trim());
      const headers = rows[0].split(',');
      addressData = rows.slice(1).map(row => {
        const cols = row.split(',');
        const obj: any = {};
        headers.forEach((h, i) => obj[h.trim()] = cols[i]?.trim());
        return obj;
      });
    } catch (e) { console.error('Failed to load address data', e); }
  }

  function getFieldInput(iid: any, field: string, value: any, rowData?: any) {
    const val = (value === null || value === undefined) ? '' : value;
    const addressFields = ['district_en', 'district_bn', 'upazilla_en', 'upazilla_bn', 'union_en', 'union_bn'];
    
    if (dropdownOptions[field]) {
      const options = [...dropdownOptions[field]];
      if (val && !options.includes(val)) options.push(val);
      return `
        <select class="val-input" data-iid="${iid}" data-field="${field}">
          <option value="">--Select--</option>
          ${options.map(opt => `<option value="${opt}" ${opt === val ? 'selected' : ''}>${opt}</option>`).join('')}
        </select>
      `;
    }
    
    if (addressFields.includes(field)) {
      let options: any[] = [];
      if (field.includes('district')) {
        options = [...new Set(addressData.map(d => field.endsWith('_en') ? d.district_en : d.district_bn))];
      } else if (field.includes('upazilla')) {
        const dist = rowData?.district_en || '';
        options = [...new Set(addressData.filter(d => !dist || d.district_en === dist).map(d => field.endsWith('_en') ? d.upazila_en : d.upazila_bn))];
      } else if (field.includes('union')) {
        const upz = rowData?.upazilla_en || '';
        options = [...new Set(addressData.filter(d => !upz || d.upazila_en === upz).map(d => field.endsWith('_en') ? d.union_en : d.union_bn))];
        const pourashava = field.endsWith('_en') ? 'POURASHAVA' : 'পৌরসভা';
        if (!options.includes(pourashava)) options.push(pourashava);
      }

      if (val && !options.includes(val)) options.push(val);

      return `
        <select class="val-input" data-iid="${iid}" data-field="${field}">
          <option value="">--Select--</option>
          ${options.map(opt => `<option value="${opt}" ${opt === val ? 'selected' : ''}>${opt}</option>`).join('')}
        </select>
      `;
    }

    if (false) {
      let dateVal = val;
      if (val) {
        const s = String(val).trim();
        if (s.includes('T')) {
          dateVal = s.split('T')[0];
        } else {
          const parts = s.split(/[-/]/);
          if (parts.length === 3) {
            if (parts[0].length <= 2 && parts[2].length === 4) {
              dateVal = `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`;
            } else if (parts[0].length === 4 && parts[2].length <= 2) {
              dateVal = `${parts[0]}-${parts[1].padStart(2, '0')}-${parts[2].padStart(2, '0')}`;
            }
          } else {
            const d = new Date(s);
            if (!isNaN(d.getTime())) dateVal = d.toISOString().split('T')[0];
          }
        }
      }
      return `<input type="date" class="val-input" data-iid="${iid}" data-field="${field}" value="${dateVal}">`;
    }
    
    if (field.endsWith('_url')) {
      return `
        <div style="display:flex; gap:4px; align-items:center;">
          ${val ? `<img src="${val}" class="row-thumb hover-preview" data-iid="${iid}">` : ''}
          <input type="text" class="val-input" data-iid="${iid}" data-field="${field}" value="${val}" style="flex:1;">
          <button class="btn-small upload-trigger" data-iid="${iid}" data-field="${field}" title="Upload">UP</button>
          <input type="file" class="hidden-file" data-iid="${iid}" data-field="${field}" style="display:none;" accept="image/*,application/pdf">
        </div>
      `;
    }

    if (field === 'rfid_card_no') {
      return `<input type="text" class="val-input" data-iid="${iid}" data-field="${field}" value="${escapeHtml(String(val))}" readonly style="cursor:pointer;" title="Click to unlock and edit">`;
    }

    return `<input type="text" class="val-input" data-iid="${iid}" data-field="${field}" value="${escapeHtml(String(val))}">`;
  }

  function refreshTable() {
    if (currentRows.length === 0) { tbody.innerHTML = ''; return; }

    // Use selectedCols directly to maintain selection order
    const displayCols = selectedCols;
    
    // Header
    theadRow.innerHTML = `
      <tr>
        <th>SL</th><th>iid</th><th>student_name_en</th>
        ${displayCols.map(c => `<th>${c}${editableCols.includes(c) ? ' <span style="color:#0061f2">(Edit)</span>' : ''}</th>`).join('')}
        <th>Update</th>
      </tr>
    `;

    // Body
    tbody.innerHTML = currentRows.map((r, idx) => `
      <tr>
        <td>${idx+1}</td>
        <td><a href="/edit_details?iid=${r.iid}" style="color:#0061f2; text-decoration:none;">${r.iid}</a></td>
        <td>${escapeHtml(r.student_name_en)}</td>
        ${displayCols.map(c => {
          if (editableCols.includes(c)) {
            return `<td>${getFieldInput(r.iid, c, r[c], r)}</td>`;
          } else {
            const val = (r[c] === null || r[c] === undefined) ? '' : r[c];
            return `<td>${escapeHtml(String(val))}</td>`;
          }
        }).join('')}
        <td><button class="update-btn" data-iid="${r.iid}" id="btn-${r.iid}">Update</button></td>
      </tr>
    `).join('');


    // Add input listeners for dirty state and paired updates
    tbody.querySelectorAll('.val-input').forEach(input => {
      input.addEventListener('change', (e: any) => {
        const iid = e.target.dataset.iid;
        const field = e.target.dataset.field;
        const val = e.target.value;
        
        // Paired updates for address
        if (addressData.length > 0) {
          let pairField = '';
          let matchKey = '';
          let pairKey = '';
          
          if (field === 'district_en') { pairField = 'district_bn'; matchKey = 'district_en'; pairKey = 'district_bn'; }
          else if (field === 'district_bn') { pairField = 'district_en'; matchKey = 'district_bn'; pairKey = 'district_en'; }
          else if (field === 'upazilla_en') { pairField = 'upazilla_bn'; matchKey = 'upazila_en'; pairKey = 'upazila_bn'; }
          else if (field === 'upazilla_bn') { pairField = 'upazilla_en'; matchKey = 'upazila_bn'; pairKey = 'upazila_en'; }
          else if (field === 'union_en') { pairField = 'union_bn'; matchKey = 'union_en'; pairKey = 'union_bn'; }
          else if (field === 'union_bn') { pairField = 'union_en'; matchKey = 'union_bn'; pairKey = 'union_en'; }

          if (pairField) {
            let matchVal = '';
            if (val === 'POURASHAVA') matchVal = 'পৌরসভা';
            else if (val === 'পৌরসভা') matchVal = 'POURASHAVA';
            else {
              const match = addressData.find(d => d[matchKey] === val);
              if (match) matchVal = match[pairKey];
            }

            if (matchVal) {
              const row = currentRows.find(x => x.iid == iid);
              if (row) row[pairField] = matchVal;
            }
          }
        }

        const btn = document.getElementById(`btn-${iid}`);
        if (btn) btn.classList.add('dirty');
      });
      input.addEventListener('input', (e: any) => {
        const iid = e.target.dataset.iid;
        const btn = document.getElementById(`btn-${iid}`);
        if (btn) btn.classList.add('dirty');
      });
    });

    // Password protection to unlock editing for RFID Card No
    tbody.querySelectorAll('.val-input[data-field="rfid_card_no"]').forEach((input: any) => {
      input.onclick = () => {
        if (input.readOnly) {
          const pwd = prompt('Enter password to edit RFID Card No:');
          if (pwd === '11223') {
            input.readOnly = false;
            input.style.cursor = 'text';
            input.title = '';
            input.focus();
          } else if (pwd !== null) {
            alert('Incorrect password!');
          }
        }
      };
    });

    // Upload Logic
    tbody.querySelectorAll('.upload-trigger').forEach((btn: any) => {
      btn.onclick = (e: any) => {
        const iid = e.target.dataset.iid;
        const field = e.target.dataset.field;
        const fileInp = tbody.querySelector(`.hidden-file[data-iid="${iid}"][data-field="${field}"]`) as HTMLInputElement;
        if (fileInp) fileInp.click();
      };
    });

    tbody.querySelectorAll('.hidden-file').forEach((fileInp: any) => {
      fileInp.onchange = async (e: any) => {
        const file = e.target.files[0];
        if (!file) return;
        
        const iid = e.target.dataset.iid;
        const field = e.target.dataset.field;
        const trigger = tbody.querySelector(`.upload-trigger[data-iid="${iid}"][data-field="${field}"]`) as HTMLButtonElement;
        const textInp = tbody.querySelector(`.val-input[data-iid="${iid}"][data-field="${field}"]`) as HTMLInputElement;
        
        trigger.textContent = '...';
        trigger.disabled = true;

        try {
          const formData = new FormData();
          formData.append('image', file);
          const response = await fetch(`https://api.imgbb.com/1/upload?key=${IMGBB_API_KEY}`, {
            method: 'POST',
            body: formData
          });

          if (!response.ok) throw new Error('ImgBB upload failed');
          const resData = await response.json();
          if (!resData.success) throw new Error(resData.error?.message || 'Upload failed');
          
          const publicUrl = resData.data.url;
          textInp.value = publicUrl;
          
          const btn = document.getElementById(`btn-${iid}`);
          if (btn) btn.classList.add('dirty');
          
          trigger.textContent = 'OK';
        } catch (err: any) {
          alert('Upload failed: ' + err.message);
          trigger.textContent = 'ERR';
        } finally {
          trigger.disabled = false;
        }
      };
    });

    tbody.querySelectorAll('.update-btn').forEach((btn: any) => {
      btn.onclick = async (e: any) => {
        const iid = e.target.dataset.iid;
        const inputs = tbody.querySelectorAll(`.val-input[data-iid="${iid}"]`) as NodeListOf<HTMLInputElement | HTMLSelectElement>;
        if (inputs.length === 0) return;
        
        e.target.textContent = '...';
        showSavePopup('saving');
        
        // Prepare update data
        const updateData: any = {};
        inputs.forEach(input => {
          const field = input.dataset.field!;
          const value = input.value === '' ? null : input.value;
          updateData[field] = value;
        });
        
        // Include paired field if it was updated
        const row = currentRows.find(x => x.iid == iid);
        if (row) {
          const pairFields: any = {
            district_en: 'district_bn', district_bn: 'district_en',
            upazilla_en: 'upazilla_bn', upazilla_bn: 'upazilla_en',
            union_en: 'union_bn', union_bn: 'union_en'
          };
          inputs.forEach(input => {
            const field = input.dataset.field!;
            if (pairFields[field]) {
              updateData[pairFields[field]] = row[pairFields[field]];
            }
          });
        }

        const { error } = await sb.from(tableName).update(updateData).eq('iid', iid);
        
        if (!error) {
          showSavePopup('success');
          e.target.textContent = 'Update';
          e.target.classList.remove('dirty');
          // Update local row state
          if (row) {
            Object.keys(updateData).forEach(k => row[k] = updateData[k]);
          }
        } else {
          showSavePopup('error', error.message || 'Row update failed');
          e.target.textContent = 'Error';
          console.error(error);
        }
      };
    });

    // Photo Preview Logic
    const previewEl = document.getElementById('photo-preview')!;
    const previewImg = previewEl.querySelector('img')!;
    tbody.querySelectorAll('.row-thumb').forEach((img: any) => {
      img.addEventListener('mouseenter', (e: any) => {
        const src = e.target.src;
        if (src) {
          previewImg.src = src;
          previewEl.style.display = 'block';
        }
      });
      img.addEventListener('mouseleave', () => {
        previewEl.style.display = 'none';
      });
    });
  }

  // selectAll & clearAll
  document.getElementById('selectAll')!.onclick = () => {
    selectedCols = allCols.map(c => c.id);
    renderCheckboxes();
    fetchData();
    saveSettings();
  };
  document.getElementById('clearAll')!.onclick = () => {
    selectedCols = [];
    renderCheckboxes();
    refreshTable();
    saveSettings();
  };

  sessionSelect.onchange = () => { loadClasses(); fetchData(); saveSettings(); };
  classSelect.onchange = () => { loadSections(); fetchData(); saveSettings(); };
  sectionSelect.onchange = () => { fetchData(); saveSettings(); };

  editCount.value = savedEditCount;

  function updateEditableCols() {
    const count = parseInt(editCount.value);
    editableCols = selectedCols.slice(-count);
  }

  editCount.onchange = () => { updateEditableCols(); saveSettings(); renderCheckboxes(); fetchData(); };
  
  updateEditableCols();
  renderCheckboxes();
  await loadAddressData();

  sessionSelect.onchange = () => { loadClasses(); fetchData(); saveSettings(); };
  classSelect.onchange = () => { loadSections(); fetchData(); saveSettings(); };
  sectionSelect.onchange = () => { fetchData(); saveSettings(); };

  // Fetch unique sections for dropdowns
  const { data: sectionData } = await sb.from(tableName).select('active_section').not('active_section', 'is', null);
  if (sectionData) {
    const sections = [...new Set(sectionData.map(r => r.active_section))].sort();
    ['active_section', 'section_2024', 'section_2025', 'section_2026'].forEach(key => {
      dropdownOptions[key] = sections;
    });
  }

  if (savedSes) {
    await loadClasses(savedCls);
    if (savedCls) {
      await loadSections(savedSec);
      fetchData();
    }
  } else {
    await loadClasses();
  }
}

function showSavePopup(status: 'saving' | 'success' | 'error', message: string = '') {
  let popup = document.getElementById('beautiful-save-popup');
  if (!popup) {
    popup = document.createElement('div');
    popup.id = 'beautiful-save-popup';
    popup.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(15, 23, 42, 0.4);
      backdrop-filter: blur(8px);
      -webkit-backdrop-filter: blur(8px);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 99999;
      opacity: 0;
      transition: opacity 0.3s ease;
    `;
    document.body.appendChild(popup);
  }

  let contentHtml = '';
  if (status === 'saving') {
    contentHtml = `
      <div style="
        background: rgba(255, 255, 255, 0.85);
        backdrop-filter: blur(20px);
        border: 1px solid rgba(255, 255, 255, 0.4);
        padding: 24px 40px;
        border-radius: 24px;
        box-shadow: 0 20px 40px -10px rgba(0, 0, 0, 0.15);
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        transform: translateY(20px);
        transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
        font-family: sans-serif;
      " id="beautiful-save-card">
        <div style="
          width: 40px;
          height: 40px;
          border: 4px solid rgba(14, 165, 233, 0.1);
          border-top: 4px solid #0ea5e9;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        "></div>
        <div style="font-weight: 700; color: #1e293b; font-size: 16px; letter-spacing: -0.2px;">Saving...</div>
      </div>
    `;
  } else if (status === 'success') {
    contentHtml = `
      <div style="
        background: rgba(255, 255, 255, 0.85);
        backdrop-filter: blur(20px);
        border: 1px solid rgba(255, 255, 255, 0.4);
        padding: 24px 40px;
        border-radius: 24px;
        box-shadow: 0 20px 40px -10px rgba(0, 0, 0, 0.15);
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        transform: translateY(0);
        font-family: sans-serif;
      " id="beautiful-save-card">
        <div style="
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background: rgba(16, 185, 129, 0.1);
          color: #10b981;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          font-weight: bold;
          border: 2px solid rgba(16, 185, 129, 0.2);
        ">✓</div>
        <div style="font-weight: 700; color: #1e293b; font-size: 16px; letter-spacing: -0.2px;">Saveing, .. ok done.</div>
      </div>
    `;
  } else {
    contentHtml = `
      <div style="
        background: rgba(255, 255, 255, 0.85);
        backdrop-filter: blur(20px);
        border: 1px solid rgba(255, 255, 255, 0.4);
        padding: 24px 40px;
        border-radius: 24px;
        box-shadow: 0 20px 40px -10px rgba(0, 0, 0, 0.15);
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        transform: translateY(0);
        font-family: sans-serif;
      " id="beautiful-save-card">
        <div style="
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background: rgba(239, 68, 68, 0.1);
          color: #ef4444;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          font-weight: bold;
          border: 2px solid rgba(239, 68, 68, 0.2);
        ">✗</div>
        <div style="font-weight: 700; color: #1e293b; font-size: 16px; letter-spacing: -0.2px;">Error: ${message}</div>
      </div>
    `;
  }

  if (!document.getElementById('popup-spin-style')) {
    const style = document.createElement('style');
    style.id = 'popup-spin-style';
    style.innerHTML = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);
  }

  popup.innerHTML = contentHtml;
  popup.style.display = 'flex';
  
  setTimeout(() => {
    popup!.style.opacity = '1';
    const card = document.getElementById('beautiful-save-card');
    if (card) card.style.transform = 'translateY(0)';
  }, 10);

  if (status === 'success' || status === 'error') {
    setTimeout(() => {
      popup!.style.opacity = '0';
      const card = document.getElementById('beautiful-save-card');
      if (card) card.style.transform = 'translateY(20px)';
      setTimeout(() => {
        popup!.style.display = 'none';
      }, 300);
    }, 2000);
  }
}
